@if (sidebarService.isSidebarVisible() || sidebarService.isMobile()) {
  <nav class="sidebar">
    <div class="sidebar-header">
      <img
        class="logo-image"
        src="/images/header_logo.svg"
        alt="Full Scale Solutions"
      />
      @if (!sidebarService.isMobile()) {
        <button class="collapse-btn" (click)="sidebarService.toggle()">
          <i class="pi pi-angle-double-left text-gray-400"></i>
        </button>
      }
    </div>

    <div class="flex flex-column justify-content-between h-full sidebar-menu">
      <div>
        @for (group of menuGroups; track group.title) {
          <div class="mb-3">
            <span class="text-xs-bold text-gray-400">{{ group.title }}</span>
            @for (item of group.items; track item.route) {
              <a [routerLink]="item.route"
                 routerLinkActive="active"
                 #rla="routerLinkActive"
                 (mouseenter)="hoveredRoute = item.route"
                 (mouseleave)="hoveredRoute = null"
                 (click)="onMenuItemClick()"
                 class="flex align-content-center menu-item">
                <app-dynamic-icon [iconComponent]="item.iconComponent" [stroke]="rla.isActive || hoveredRoute === item.route ? '#181D27' : '#7E838F'"></app-dynamic-icon>
                <span class="text-md-semibold text-gray-700 hover:text-gray-900 ml-2-5">{{ item.label }}</span>
                @if (item.badge) {
                  <span class="badge">{{ item.badge }}</span>
                }
              </a>
            }
          </div>
        }
      </div>
      <div class="sidebar-footer">
        <a routerLink="/admin/settings"
           routerLinkActive="active"
           #rlaSettings="routerLinkActive"
           (mouseenter)="hoveredRoute = '/admin/settings'"
           (mouseleave)="hoveredRoute = null"
           (click)="onMenuItemClick()"
           class="flex align-content-center menu-item">
          <app-settings-01 [stroke]="rlaSettings.isActive || hoveredRoute === '/admin/settings' ? '#181D27' : '#7E838F'"></app-settings-01>
          <span class="text-md-semibold text-gray-700 ml-2-5 hover:text-gray-900">Podešavanja</span>
        </a>
        @if (name) {
          <div class="user-card" (click)="toggleUserCardMenu($event)">
            <div class="user-avatar text-md-semibold text-gray-500">{{getInitials(name)}}</div>
            <div class="user-info">
              <span class="text-sm-semibold text-gray-900">{{name}}</span>
              <span class="text-sm-regular text-gray-600">Admin</span>
            </div>
            <i class="pi pi-angle-right"></i>
          </div>
          <p-menu #userCardMenu [model]="userCardMenuItems" [popup]="true"></p-menu>
        }
      </div>
    </div>
  </nav>
}
